import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4979ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-config" }
const _hoisted_2 = { class: "nav-config_item" }
const _hoisted_3 = { class: "nav-config_item_r" }
const _hoisted_4 = { class: "nav-config_item_r_name" }
const _hoisted_5 = {
  key: 0,
  class: "nav-config_item_r_slogan"
}


const __default__ = {
  name: 'CreateConfig'
}

import Icon from '@teams/common/components/icon'
import { IViewOption } from '@teams/common/hooks/useAddOrUpdateNav'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null,
    size: { default: 24 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Icon), {
        name: __props.item.icon,
        size: __props.size,
        fill: "transparent"
      }, null, 8, ["name", "size"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.item.name), 1),
        (__props.item.slogan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.item.slogan), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})